<h1>Welcome to Platform UI!!!</h1>
<router-outlet></router-outlet>
